import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import * as Type from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { putSaga } from "src/request/put";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { deleteSaga } from "src/request/delete";

//***CONTRACT STATUS***//
export const getContractStatuses = createAction(
  "GET_CONTRACTSTATUSES",
  ({ payload, params }: SagaActionParams<Type.ContractStatusDto[]>) => ({
    payload,
    url: "/api/admin/contractstatus" + (params ? params : ""),
  })
);
export const getContractStatusDetails = createAction(
  "GET_CONTRACTSTATUS_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ContractStatusDetailDto>) => ({
    payload,
    url: "/api/admin/contractstatus/" + id,
  })
);
export const createContractStatus = createAction(
  "CREATE_CONTRACTSTATUS",
  ({ payload, body }: SagaActionParams<Type.ContractStatusDto>) => ({
    payload,
    url: "/api/admin/contractstatus",
    body,
  })
);
export const updateContractStatus = createAction(
  "UPDATE_CONTRACTSTATUS",
  ({ payload, id, body }: SagaActionParams<Type.ContractStatusDto>) => ({
    payload,
    url: "/api/admin/contractstatus/" + id,
    body,
  })
);
export const deleteContractStatus = createAction(
  "DELETE_CONTRACTSTATUS",
  ({ payload, id }: SagaActionParams<Type.ContractStatusDto>) => ({
    payload,
    url: "/api/admin/contractstatus/" + id,
  })
);

const contractStatusSaga = [
  //***************CONTRACT STATUS***************//
  takeLatest<any>(
    getContractStatuses.toString(),
    (payload: SagaGenericParams<Type.ContractStatusDto[]>) =>
      getSaga<Type.ContractStatusDto[]>(payload)
  ),
  takeLatest<any>(
    getContractStatusDetails.toString(),
    (payload: SagaGenericParams<Type.ContractStatusDetailDto>) =>
      getSaga<Type.ContractStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    createContractStatus.toString(),
    (payload: SagaGenericParams<Type.ContractStatusDetailDto>) =>
      postSaga<Type.ContractStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    updateContractStatus.toString(),
    (payload: SagaGenericParams<Type.ContractStatusDetailDto>) =>
      putSaga<Type.ContractStatusDetailDto>(payload)
  ),
  takeLatest<any>(
    deleteContractStatus.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ContractStatusDetailDto>(payload)
  ),
];

export default contractStatusSaga;
